import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";
import Map from "@/models/PlatinumWidget/Map/Map";

export default class Region extends BossModel {

    /**
     * @type {string}
     */
    static apiUrl = 'region';

    /**
     * @type {string}
     */
    static entity = 'regions';

    static fields() {
        return {
            id: this.number(null).nullable(),
            parent_id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
            region_type_id: this.number(null).nullable(),
            code: this.attr(null),
            name: this.attr(null),
            center_lat: this.number(null).nullable(),
            center_lng: this.number(null).nullable(),
            min_lat: this.number(null).nullable(),
            min_lng: this.number(null).nullable(),
            max_lat: this.number(null).nullable(),
            max_lng: this.number(null).nullable(),
            zoom: this.number(null).nullable(),
            allow_zoom_in: this.number(null).nullable(),
            allow_zoom_out: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            url: this.attr(null),
            deleted_at: this.attr(null),
            parent: this.belongsTo(Region, 'parent_id'),
            country: this.belongsTo(Country, 'country_id'),
            map: this.belongsTo(Map, 'id'),
        }
    }

    /**
     * @param ids
     * @returns {*}
     */
    static byIds(ids) {
        return this.all().filter(item => ids.includes(item.id));
    }

    /**
     * @param params
     * @returns {*}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get();
    }

    static makeTree(nodes) {
        const nodeMap = {};

        // Populate the nodeMap with items grouped by their parent_id
        nodes.forEach(node => {
            const parentId = node.parent_id || null;
            if (!nodeMap[parentId]) {
                nodeMap[parentId] = [];
            }
            nodeMap[parentId].push(node);
        });

        // Recursive function to build the tree structure
        const buildTree = (parentId = null) => {
            const childNodes = nodeMap[parentId] || [];
            childNodes.sort((nodeA, nodeB) => nodeA.name.localeCompare(nodeB.name));

            return childNodes.map(node => ({
                ...node,
                name: `${node.name} (${node.code ?? '-'})`,
                children: buildTree(node.id),
            }));
        };

        return buildTree();
    }

    /**
     * @returns {boolean|*}
     * @constructor
     */
    Parent() {
        return this.getRelated('parent');
    }

    /**
     * @returns {boolean|*}
     * @constructor
     */
    Country() {
        return this.getRelated('country');
    }
}
